import { IGetVillageListRequestSchema } from '../../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../../types/store';
import {
  THeatingSourceTypesChanged,
  TSaleStatusChanged,
  THouseMaterialChanged,
  TReadyStatusChanged,
  TOtherCommunicationChanged,
} from '../../../store/filters/actions';

export interface IExtraFilterStoreProps<T> {
  selected: T[];
}

export interface IExtraFilterDispatchProps<T> {
  toggle(value: T): void;
}

type TFilterArrays = Pick<
  IGetVillageListRequestSchema,
  'heatingSourceType' | 'saleStatus' | 'readyStatus' | 'houseMaterialType' | 'otherCommunications'
>;
type TFilterArraysActions =
  | THeatingSourceTypesChanged
  | TSaleStatusChanged
  | THouseMaterialChanged
  | TReadyStatusChanged
  | TOtherCommunicationChanged;

export const mapStateToPropsCreator =
  <T extends string>(key: keyof TFilterArrays) =>
  (state: IApplicationState): IExtraFilterStoreProps<T> => ({ selected: (state.filters[key] as T[]) || [] });

export const mapDispatchToPropsCreator =
  <T>(action: (payload: T) => TFilterArraysActions) =>
  (dispatch: TTypedThunkDispatch): IExtraFilterDispatchProps<T> => ({
    toggle: value => dispatch(action(value)),
  });
